import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { Election as ElectionModel } from '../../../models/vote';
import { getClub } from '../../../service/clubs';
import { getElectionResult, getUserVoteByUserAndElectionId } from '../../../service/election';
import { useUserStore } from '../../../store/useUser';
import { button_color } from '../../../styles/_variables';
import { formatDate } from '../../../utils/date';
import ClubImage from '../../../components/ClubImage/ClubImage';
import Icon from '../../../components/Icon/Icon';
import styles from './Election.module.scss';
import { getElectionType } from '../../../utils/election';
import Card from '../../../components/Card/Card';

export const Check = () => {
  return (
    <div className= {styles.check} >
      <Icon icon='check' color = { button_color } />
      Votado
    </div>
  )
}

interface Props{
  election: ElectionModel;
}

export const Election = ({election}: Props) => {
  const navigate = useNavigate();

  const userId = useUserStore(state => state.id)
  const profile = useUserStore(state => state.profile)

  const electionIsFinish = new Date(election.finalDate) < new Date()

  const isAdminOrMediator = profile === 'Criador' || profile === 'Mediador'

  const {data:ballotBox, isFetching } = useQuery(
    ['ballotBox', election?.id],
    () => getUserVoteByUserAndElectionId(userId, election?.id),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false, enabled:!isAdminOrMediator},
  );

  const onClick = () => {
    navigate(`/club/${election.clubId}/election/${election?.id}/candidates/${election?.typeVote}`)
  }
  
  return (
    <div className={styles.containerElections} onClick={onClick}>
      <Card>
        <header>
          <Club key={election.clubId} clubId={election.clubId}/>
        </header>
        <div style={{ marginTop: 10 }}>
          {electionIsFinish
            ? "Finalizado"
            : <>Até <strong>{formatDate(election.finalDate)}</strong><br /></>
          }
        </div>
        <div style={{marginTop: 10}}>
          <strong>{getElectionType(election.typeVote)}</strong>
        </div>
      </Card>

      {ballotBox?.id && !isAdminOrMediator && <Check />}
    </div>
  )
}

export const Club = ({clubId}) => {
  const {data:club, isFetching} = useQuery(
    ['club', clubId],
    () => getClub(clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  return (
      <div >
        <header className={styles.clubHeader}>
          <ClubImage clubName={club?.name} path={club?.pathPhoto}/>
        <strong>{club?.name}</strong>
      </header>
    </div>
  )
}